module.exports = __webpack_public_path__ + "static/media/06.7f43db3b.jpg";